import { Stack } from "@mui/material";
import useResponsive from "src/hooks/useResponsive";

import FormTitle from "./components/FormTitle";
import Header from "./components/Header";
import TermsLinks from "./components/TermsLinks";
import VumiTitle from "./components/VumiTitle";
import LoginForm from "./LoginForm/LoginForm";

// ----------------------------------------------------------------------

export const LoginContent = () => {
	const isMobile = useResponsive("down", "sm");
	return (
		<>
			{isMobile && <Header />}
			<Stack sx={{ alignItems: isMobile ? "initial" : "center", p: 3 }}>
				<Stack sx={{ width: { xs: "auto", sm: 400 } }}>
					<FormTitle />
					<LoginForm />
					<TermsLinks />
				</Stack>
			</Stack>
			{!isMobile && <VumiTitle />}
		</>
	);
};

export default LoginContent;
